import Link from "next/link";
import styles from './poperties.module.css'
import global from '../bid.module.css';
import buttons from "components/_styled/buttons.module.css";
import Card from "./Card";

type Props = {
  selectedProperties: [
    {
      url: string, 
      type: string, 
      full_name: string | undefined, 
      category_code: string, 
      thumbnail: undefined, 
      sponsored: boolean | undefined, 
      description: string, 
      price: string, 
      availability: object, 
      size: string | undefined, 
      rent: string |undefined, 
      id: {
        raw: string
      }, 
      marketedBy: [
        {
          id: string,
          name: string
        }
      ], 
      owners: [
        {
          company_id: string,
          company_name: string
          paying_client: boolean,
          name: string,
          logo_uri: string
        }
      ], 
      modified: string, 
      images: [{format: object}], 
      uri: object, 
      name: string, 
      number_of_available_properties: number | undefined, 
      line1: string, 
      line2: object, 
      town_name: string, 
      line3: object, 
      postcode: string, 
      url_fragment: string, 
      themeFormat: {
        primary: string,
        secondary: string
      },
      use_class: any,
      docType: string
    }
  ],
  totalProperties: number,
  location: string,
  url: string,
  themeFormat: {
    primary: string,
    secondary: string
  },
}

const Properties = ({ selectedProperties, totalProperties, location, url, themeFormat }: Props) => {
  const showing = selectedProperties !== null ? selectedProperties.length : 0;
  return (
    <div className={`${styles.Container} ${global.Container}`} id="properties" >

      <h3 className={styles.Heading}>Showing <span style={{ color: themeFormat.primary }}>{showing}</span> of <span style={{ color: themeFormat.primary }}>{totalProperties}</span> shops to let in {location}</h3>

      <ul className={styles.Results}>
        {selectedProperties.map((property, index) => (
          <Card key={`propertyOuter-${property.id.raw}`} {...property} type={property.docType} themeFormat={themeFormat} />
        ))}
      </ul>

      <Link href={`/destinations/${url}/shops-to-rent`} passHref={true} prefetch={false} legacyBehavior>
        <a className={`${buttons.SecondaryButton} ${styles.Link} `}>{`View all ${totalProperties} properties`}</a>
      </Link>
    </div>
  );
};

export default Properties;
